import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-16 px-6 border-t border-slate-900" data-id="element-16">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-17">
        {/* Brand Column */}
        <div className="col-span-1" data-id="element-18">
          <Link to="/" className="flex items-center gap-2.5 mb-6" data-id="element-19">
            <img src="https://cdn.magicpatterns.com/uploads/5Ckf69r6uEupqjpPQCFvvo/Black_Logo.png" alt="D2D Guides" className="h-8 w-8 object-contain brightness-0 invert" data-id="element-20" />
            <span className="font-bold text-white tracking-tight text-lg" data-id="element-21">
              D2D Guides
            </span>
          </Link>
          <p className="text-sm leading-relaxed text-slate-500 mb-6" data-id="element-22">
            The independent evaluation platform for the door-to-door industry.
            Helping operators and reps understand tradeoffs before they pay the
            price.
          </p>
        </div>

        {/* For Businesses */}
        <div data-id="element-23">
          <h4 className="text-white font-bold mb-6 text-sm" data-id="element-24">For Businesses</h4>
          <ul className="space-y-3 text-sm" data-id="element-25">
            <li data-id="element-26">
              <Link to="/category/crms" className="hover:text-teal-500 transition-colors" data-id="element-27">
                CRM Reviews
              </Link>
            </li>
            <li data-id="element-28">
              <Link to="/category/recruiting" className="hover:text-teal-500 transition-colors" data-id="element-29">
                Recruiting Services
              </Link>
            </li>
            <li data-id="element-30">
              <Link to="/category/training" className="hover:text-teal-500 transition-colors" data-id="element-31">
                Training Platforms
              </Link>
            </li>
            <li data-id="element-32">
              <Link to="/category/support" className="hover:text-teal-500 transition-colors" data-id="element-33">
                Support Services
              </Link>
            </li>
            <li data-id="element-34">
              <Link to="/category/crms" className="hover:text-teal-500 transition-colors" data-id="element-35">
                POS Systems
              </Link>
            </li>
          </ul>
        </div>

        {/* For Reps */}
        <div data-id="element-36">
          <h4 className="text-white font-bold mb-6 text-sm" data-id="element-37">For Reps</h4>
          <ul className="space-y-3 text-sm" data-id="element-38">
            <li data-id="element-39">
              <Link to="/category/industries" className="hover:text-teal-500 transition-colors" data-id="element-40">
                Industry Comparisons
              </Link>
            </li>
            <li data-id="element-41">
              <Link to="/category/compensation" className="hover:text-teal-500 transition-colors" data-id="element-42">
                Compensation Models
              </Link>
            </li>
            <li data-id="element-43">
              <Link to="/category/work-models" className="hover:text-teal-500 transition-colors" data-id="element-44">
                Work Models (W2 vs 1099)
              </Link>
            </li>
            <li data-id="element-45">
              <Link to="/category/career-paths" className="hover:text-teal-500 transition-colors" data-id="element-46">
                Career Paths
              </Link>
            </li>
            <li data-id="element-47">
              <Link to="/category/territories" className="hover:text-teal-500 transition-colors" data-id="element-48">
                Market Analysis
              </Link>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div data-id="element-49">
          <h4 className="text-white font-bold mb-6 text-sm" data-id="element-50">Platform</h4>
          <ul className="space-y-3 text-sm" data-id="element-51">
            <li data-id="element-52">
              <Link to="/methodology" className="hover:text-teal-500 transition-colors" data-id="element-53">
                Methodology
              </Link>
            </li>
            <li data-id="element-54">
              <Link to="/methodology" className="hover:text-teal-500 transition-colors" data-id="element-55">
                Transparency Policy
              </Link>
            </li>
            <li data-id="element-56">
              <Link to="/about" className="hover:text-teal-500 transition-colors" data-id="element-57">
                About Us
              </Link>
            </li>
            <li data-id="element-58">
              <Link to="/about" className="hover:text-teal-500 transition-colors" data-id="element-59">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-6xl mx-auto pt-8 border-t border-slate-900 text-xs text-slate-600 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-60">
        <p data-id="element-61">© {new Date().getFullYear()} D2D Guides. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-62">
          <span data-id="element-63">Editorially Independent</span>
          <span data-id="element-64">Transparent</span>
          <span data-id="element-65">Standardized</span>
        </div>
      </div>
    </footer>;
}